export const BUILDINGS_FORM = [
  {
    name: "name",
    type: "text",
    placeholder: "Building Name",
    label: "Building Name:",
    required: true,
  },
  {
    name: "location.address",
    type: "text",
    placeholder: "Address",
    label: "Address:",
    required: true,
  },
  {
    name: "location.city",
    type: "text",
    placeholder: "City",
    label: "City:",
    required: true,
  },
  {
    name: "location.state",
    type: "text",
    placeholder: "State",
    label: "State:",
    required: true,
  },
  {
    name: "location.country",
    type: "text",
    placeholder: "Country",
    label: "Country:",
    required: true,
  },
];
